import callApi from '../../util/apiCaller';
// Export Constants
export const MY_REP_FETCH_ALL_REPS = 'MY_REP_FETCH_ALL_REPS';
export const MY_REP_FETCH_MY_REPS = 'MY_REP_FETCH_MY_REPS';
export const MY_REP_UPDATE_MY_REPS = 'MY_REP_UPDATE_MY_REPS';
export const MY_REP_FETCH_MANAGER_LIST = 'MY_REP_FETCH_MANAGER_LIST';

export function fetchAllReps() {
  const empty = {
    reps: [],
    status: null,
    errors: null,
  };
  return (dispatch) => {
    dispatch({
      type: MY_REP_FETCH_ALL_REPS, ...empty, status: 'loading', errors: null,
    });

    const p4 = callApi('manager-reps/members', 'GET');

    const p = new Promise((resolve, reject) => {
      Promise.all([p4]).then(
        ([{ members }]) => {
          resolve({ reps: members });
        },
        (errors) => {
          reject(errors);
        },
      );
    });

    p.then(
      (results) => {
        dispatch({
          type: MY_REP_FETCH_ALL_REPS,
          ...empty,
          ...results,
          status: 'loaded',
          errors: null,
        });
      },
      (errors) => {
        dispatch({
          type: MY_REP_FETCH_ALL_REPS, ...empty, status: 'error', errors,
        });
      },
    );
    return p;
  };
}


export function resetAll() {
  return (dispatch) => {
    const p1 = dispatch({
      type: MY_REP_FETCH_ALL_REPS, status: null, errors: null, reps: [],
    });
    const p2 = dispatch({
      type: MY_REP_FETCH_MY_REPS, status: null, errors: null, reps: [],
    });

    const p = new Promise((resolve) => {
      Promise.all([p1, p2]).then(() => { resolve(); });
    });

    return p;
  };
}

export function fetchManagerList() {
  return (dispatch) => {
    const p = callApi('manager-reps/count-managers', 'GET');
    p.then(({ reps }) => dispatch({ type: MY_REP_FETCH_MANAGER_LIST, reps }));
    return p;
  };
}

export function addReps(params) {
  return (dispatch) => {
    const p = callApi('manager-reps', 'POST', params);
    p.then(({ reps }) => dispatch({ type: MY_REP_UPDATE_MY_REPS, reps }));
    return p;
  };
}
export function updateReps(id, params) {
  return (dispatch) => {
    const p = callApi(`manager-reps/${id}`, 'PUT', params);
    p.then(({ reps }) => dispatch({ type: MY_REP_UPDATE_MY_REPS, reps, id }));
    return p;
  };
}
export function removeReps(id) {
  return (dispatch) => {
    const p = callApi(`manager-reps/${id}`, 'DELETE');
    p.then(({ reps }) => dispatch({ type: MY_REP_UPDATE_MY_REPS, reps, id }));
    return p;
  };
}

export function fetchMyReps() {
  const empty = {
    reps: [],
    status: null,
    errors: null,
  };
  return (dispatch) => {
    dispatch({
      type: MY_REP_FETCH_MY_REPS,
      ...empty,
      status: 'loading',
      errors: null,
    });

    const p4 = callApi('manager-reps', 'GET');

    const p = new Promise((resolve, reject) => {
      Promise.all([p4]).then(
        ([{ reps }]) => {
          resolve({ reps });
        },
        (errors) => {
          reject(errors);
        },
      );
    });

    p.then(
      (results) => {
        dispatch({
          type: MY_REP_FETCH_MY_REPS,
          ...empty,
          ...results,
          status: 'loaded',
          errors: null,
        });
      },
      (errors) => {
        dispatch({
          type: MY_REP_FETCH_MY_REPS,
          ...empty,
          status: 'error',
          errors,
        });
      },
    );
    return p;
  };
}
